import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import {
  Box, Button, Columns,
} from '@domain-group/suit-theme'

import type { UseBrandPayload } from '@hooks/useBrand'
import useCurrentUser from '@hooks/useCurrentUser'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'
import PageHeader from '@components/PageHeader'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { BrandModel } from '@models/types'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: React.ReactNode,
  entityPayload: {
    brand: Partial<BrandModel>,
    callbacks: {
      loginAsBrand: UseBrandPayload['callbacks']['loginAsBrand'],
    },
    urls: {
      brandsIndexUrl: string,
    },
  },
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const { isBrandUser } = useCurrentUser()

  const {
    brand,
    callbacks: { loginAsBrand },
    urls: { brandsIndexUrl },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit Brand | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
            <ImpersonateEntityButton
              callbacks={{ loginAsEntity: loginAsBrand }}
              // @ts-expect-error TS2322
              entity={brand}
              marginRight="medium"
            />

            <Button
              // @ts-expect-error TS2322
              as="a"
              buttonStyle="secondaryUtility"
              href={redirect || brandsIndexUrl}
              size="medium"
              width="auto"
            >
              Back
            </Button>
          </ScopedConditionalContent>
        )}
        activeTabBarItemKey={activeTabBarItemKey || 'details'}
        tabBarItems={generateTabBarItems({ brand, isBrandUser })}
        title="Edit Brand"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
